import { nzApiAxios } from 'src/utils/nz-axios/nz-axios';
import qs from 'qs';
import { PaginatedResponse } from 'src/types/common-types';
import { CourseItem } from '../types';

export const educationApiUrl = '/EducationCourses';
const educationVendorsApiUrl = `${educationApiUrl}/vendors`;

const ApiUrls = {
  educationApiUrl,
  educationVendorsApiUrl
};

function GetSearchRequest(page = 1, query = {}): Promise<PaginatedResponse<CourseItem>> {
  return nzApiAxios
    .get(educationApiUrl, {
      params: { ...query, page },
      paramsSerializer: {
        serialize: (params) => {
          return qs.stringify(params, { allowDots: true });
        }
      }
    })
    .then((value) => value.data);
}

function GetVendors(): Promise<string[]> {
  return nzApiAxios.get(educationVendorsApiUrl).then((response) => response.data);
}

const API = {
  search: GetSearchRequest,
  getVendors: GetVendors
};

export { ApiUrls };
export default API;
